import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconTextFormatLink(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M3.9 12c0-1.71 1.39-3.1 3.1-3.1h3.05a.95.95 0 1 0 0-1.9H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h3.05a.95.95 0 1 0 0-1.9H7c-1.71 0-3.1-1.39-3.1-3.1ZM8 12a1 1 0 0 0 1 1h6a1 1 0 1 0 0-2H9a1 1 0 0 0-1 1Zm9-5h-3.05a.95.95 0 1 0 0 1.9H17c1.71 0 3.1 1.39 3.1 3.1 0 1.71-1.39 3.1-3.1 3.1h-3.05a.95.95 0 1 0 0 1.9H17c2.76 0 5-2.24 5-5s-2.24-5-5-5Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
